module.exports = __webpack_public_path__ + "img/crm_call_center.0004ed28.png";